import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-36cb4df4")
const _hoisted_1 = { class: "col-md-3 text-left" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "font-weight-bold"
}
const _hoisted_4 = ["value", "onUpdate:modelValue"]
const _hoisted_5 = { class: "ml-1" }
const _hoisted_6 = { class: "col-md-9 mb-4" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", null, "25", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", null, "50", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", null, "100", -1)
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { key: 1 }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemList = _resolveComponent("ItemList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keywordQueryModel?.containers, (container, cIdx) => {
        return (_openBlock(), _createElementBlock("div", { key: container }, [
          (_ctx.keywordQueryModel?.containers.length > 1 && container?.name?.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(container.name), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(container.fields, (field, fIdx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: field,
              class: "mb-3"
            }, [
              (field.name.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(field.name), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.values, (value, vIdx) => {
                return (_openBlock(), _createElementBlock("div", { key: value }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    value: value,
                    "onUpdate:modelValue": ($event: any) => (_ctx.keywordQueryModel.containers[cIdx].fields[fIdx].selected[vIdx] = $event),
                    onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.runFreshSearch && _ctx.runFreshSearch(...args)))
                  }, null, 40, _hoisted_4), [
                    [_vModelCheckbox, _ctx.keywordQueryModel.containers[cIdx].fields[fIdx].selected[vIdx]]
                  ]),
                  _createElementVNode("label", _hoisted_5, _toDisplayString(value), 1)
                ]))
              }), 128))
            ]))
          }), 128))
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.items?.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_ctx.first > 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                  _createElementVNode("i", {
                    class: "fas fa-angle-double-left",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.previousPage && _ctx.previousPage(...args)))
                  })
                ]))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.first) + "-" + _toDisplayString(_ctx.last) + " of " + _toDisplayString(_ctx.count) + " ", 1),
            (_ctx.count > _ctx.last)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                  _createElementVNode("i", {
                    class: "fas fa-angle-double-right",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchParams.max = $event)),
                class: "pull-right",
                onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.runFreshSearch && _ctx.runFreshSearch(...args)))
              }, _hoisted_13, 544), [
                [_vModelSelect, _ctx.searchParams.max]
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, "No results found.")),
      _createVNode(_component_ItemList)
    ])
  ], 64))
}